import { Component, inject, Input, signal } from '@angular/core';
import { BasicForm } from '@shared/components/classes/basic.form';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputNumberModule } from '@primeng/inputnumber';
import { InputValidatorDirective } from '@common/directive/input-validator.directive';
import { CalendarModule } from '@primeng/calendar';
import { TranslatePipe } from '@ngx-translate/core';
import { Balance } from '@modules/universal-billing/renters/renters-details/balance/balance.interfaces';
import { RenterNamePipe } from '@common/pipe/renter-name.pipe';
import { PaymentsService } from '@modules/universal-billing/accounting/payments/payments.service';
import { PaymentStatus, PaymentType } from '@modules/universal-billing/accounting/payments/payment.enum';
import { ApartmentPipe } from "@common/pipe/apartment.pipe";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from "@ng-select/ng-select";
import { formatDate } from '@shared/utils/format-date';
import { deepCopy } from '@shared/utils';
import { ContractService } from '@modules/universal-billing/contract/contract.service';
import { SkeletonModule } from '@primeng/skeleton';
import rentTypeGroups from '@common/rent-type-groups';
import { JsonPipe } from '@angular/common';
import { RentalContract } from '@modules/universal-billing/contract/contract.interface';
import { MoneyFormatPipe } from '@common/pipe/money-format.pipe';

@Component({
  selector: 'app-payments-balace-form',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    InputNumberModule,
    InputValidatorDirective,
    CalendarModule,
    TranslatePipe,
    RenterNamePipe,
    ApartmentPipe,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    SkeletonModule,
    JsonPipe,
    MoneyFormatPipe
  ],
  templateUrl: './balance-form.component.html',
  styleUrl: './balance-form.component.scss'
})
export class BalanceFormComponent extends BasicForm<any>{
  @Input() balance: Balance;
  @Input() _defaultService: PaymentsService = inject(PaymentsService);
  form: FormGroup;
  private fb: FormBuilder = inject(FormBuilder);
  dateFields = ['date'];
  paymentTypes: PaymentType[] = [PaymentType.CREDIT_CARD, PaymentType.CASH, PaymentType.BANK_TRANSFER];
  periodTitle = "";
  contractLoading = signal(true);
  contractService = inject(ContractService);
  contractPaymentFields = [];
  contract: RentalContract = null;
  ngOnInit() {
    this.periodTitle = formatDate(new Date(this.balance.period), 'MMMM yyyy');
    this.form = this.fb.group({
      period: [this.balance.period],
      renterId: [this.balance.renterId, Validators.required],
      invoiceId: [this.balance.invoiceId, Validators.required],
      amount: [this.balance.invoiceAmount, [Validators.required]],
      date: [null, Validators.required],
      type: [PaymentType.CASH, Validators.required],
      status: [PaymentStatus.PAID, [Validators.required]],
      details: ['']
    })
    super.ngOnInit();
    this.getContract();
  }
  loadData() {
    this.patchResponseData(deepCopy(this.selectedRow));
  }
  getContract() {
    this.contractLoading.set(true);
    this.contractService.getAll({ apartmentId: this.balance.apartment?.id, renterId: this.balance.renterId }).subscribe(res=> {
      if (res && res.data.length) {
        this.contract = res.data[0];
        this.contractPaymentFields = this.getRateTypeFields(this.contract);
      }
      this.contractLoading.set(false);
    })
  }
  getRateTypeFields(contract): any[] {
    if (!contract)
      return [];
    const type= rentTypeGroups.find(rt => rt.id === contract?.unitType);
    return type && type.fields ? [{
      id: 'totalRent',
      label: 'CONTRACT.TOTAL_RENT'
    },...type.fields] : [];
  }
}
